<script>
import chroma from "chroma-js";
import store from "@/store";

export default {
	props: {
		transparent: {
			type: Boolean,
			default: false
		},
		secondary: {
			type: Boolean,
			default: false
		},
		primary: {
			type: Boolean,
			default: true
		},
		styling: {
			type: String,
			default: ""
		},
		to: {
			type: [Object, String],
			default: undefined
		},
		replace: {
			type: Boolean,
			default: false
		},
		button: {
			type: Boolean,
			default: undefined
		},
		tag: {
			type: String,
			default: ""
		},
		errorState: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		loading: {
			type: [Boolean, Number],
			default: false
		}
	},
	data() {
		return {
			backgroundColor: undefined
		};
	},
	computed: {
		buttonStyle() {
			if (this.styling !== "") {
				return this.styling;
			}
			if (this.transparent) {
				return "transparent";
			}
			if (this.secondary) {
				return "secondary";
			}
			if (this.primary) {
				return "primary";
			}
			return "error";
		},
		isButton() {
			if (this.button !== undefined) {
				return this.button;
			}
			return !this.to;
		},
		getTag() {
			if (this.tag) {
				return this.tag;
			}
			if (this.to) {
				return "router-link";
			}
			return "button";
		},
		class() {
			return {
				"amigo-btn--error": this.errorState,
				"amigo-btn--loading": this.loading !== false,
				"amigo-btn--disabled": this.disabled,
				[`amigo-btn--${this.buttonStyle}`]: true
			};
		}
	},
	methods: {
		onClick(event) {
			if (this.disabled) {
				event.preventDefault();
				return;
			}
			this.$emit("click");
		},
		onMouseOver() {
			if (
				!this.secondary &&
				!this.disabled &&
				store.getters.theme.primaryColor
			) {
				const primaryColor = store.getters.theme.primaryColor;
				this.backgroundColor = chroma(primaryColor)
					.darken(0.75)
					.hex();
			}
		},
		onMouseLeave() {
			this.backgroundColor = undefined;
		}
	},
	render(h) {
		return h(
			this.getTag,
			{
				staticClass: "amigo-btn",
				class: this.class,
				style: this.backgroundColor && {
					backgroundColor: this.backgroundColor
				},
				on: {
					click: this.onClick,
					mouseover: this.onMouseOver,
					mouseleave: this.onMouseLeave
				},
				nativeOn:
					this.getTag === "button"
						? undefined
						: {
								click: this.onClick,
								mouseover: this.onMouseOver,
								mouseleave: this.onMouseLeave
						  },
				attr: {
					role:
						this.isButton && this.tag !== "button"
							? "button"
							: undefined
				},
				props: {
					to: this.to,
					replace: this.replace ? true : undefined,
					...(this.getTag === "router-link" &&
						this.disabled && {
							disabled: true,
							event: "",
							style: { cursor: "default" }
						})
				},
				directives: this.disabled
					? []
					: [
							{
								name: "ripple", // Vuetify ripple
								value: true,
								expression: "true",
								arg: true
							}
					  ]
			},
			this.loading !== false
				? [
						h("v-progress-circular", {
							staticClass: "amigo-btn__loader",
							props: {
								indeterminate: true,
								color: "white",
								size: 22,
								value:
									typeof this.loading === "number"
										? this.loading
										: undefined
							}
						}),
						h(
							"span",
							{
								staticClass: "amigo-btn__hide-text"
							},
							this.$slots.default
						)
				  ]
				: this.$slots.default
		);
	}
};
</script>

<style lang="scss">
.amigo-btn {
	text-decoration: none;
	padding: 9px 25px;
	font-family: TheSansOsF, sans-serif;
	font-size: 16px;
	font-weight: 600;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	transition: all 0.15s;
	text-align: center;
}

@media only screen and (max-width: 600px) {
	.amigo-btn {
		min-height: 48px;
	}
}

.amigo-btn--primary {
	background-color: var(--primary-color);
	color: #fff;
}

.amigo-btn--primary:hover,
.amigo-btn--primary:focus {
	background-color: var(--primary-color);
}

.amigo-btn--secondary {
	background-color: #fff;
	color: var(--secondary-color);
}

.amigo-btn--secondary:hover,
.amigo-btn--secondary:focus {
	background: var(--secondary-color);
	color: #fff;
}

.amigo-btn--transparent {
	background: transparent;
	color: #2a2a2a;
}

.amigo-btn--transparent:hover,
.amigo-btn--transparent:focus {
	color: #808080;
}

.amigo-btn.amigo-btn--error {
	background: #f06556;
	color: #2a2a2a;
}

.amigo-btn.amigo-btn--disabled {
	color: #b7b7b7;
	background-color: #f3f3f3;
}
.amigo-btn__loader {
	position: absolute !important;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}
.amigo-btn__hide-text {
	visibility: hidden;
}
</style>
